const leadPreferences = {
  leadPreferences: {
    pageHeader: 'Leads-Einstellungen',
    confirmMessage:
      'Möchten Sie Ihre Leads-Einstellungen wirklich speichern und zur Seite "Benutzer hinzufügen" wechseln?',
    notInterested: {
      radioOptions0: 'Mangel an Zeit/ Ressourcen, um neue Leads zu bedienen',
      radioOptions1: 'Nur an unterzeichneten Verträgen von Hausbesitzern interessiert',
      radioOptions2: 'Möchte Preisspanne nicht offenlegen',
      radioOptions3: 'Anderes',
      selectReason: 'Bitte wählen Sie den Grund, warum Sie nicht am Enphase Leads-Programm teilnehmen',
      otherComments: 'Weitere Anmerkungen'
    },
    programOverview: {
      notInterestedText: 'Wir sind derzeit nicht an einer Teilnahme am Enphase Leads-Programm interessiert'
    },
    serviceDetailsSection: {
      min: 'Min',
      max: 'Max',
      maxLessMin: 'Der Maximalwert darf nicht kleiner oder gleich dem Minimalwert sein',
      enterInRange: 'Bitte geben Sie nur Zahlen zwischen %{serviceMInValue} und %{serviceMaxValue} ein',
      note: 'Hinweis',
      noteText:
        'Diese Eingabe ist die Grundlage für die  Preisspanne, die dem Hausbesitzer angezeigt wird. Dieser Preis sollte Steuern, aber keine Prämien enthalten.',
      noteTextAus:
        'Diese Eingabe ist die Grundlage für die  Preisspanne, die dem Hausbesitzer angezeigt wird. Dieser Preis sollte Steuern, aber keine Prämien enthalten.',
      sizeRange: 'Größenbereich',
      pricePerkWh: 'Preis pro kWh',
      lessThan20kWh: 'Weniger als 20 kWh',
      greaterThan20kWh: '20 bis 40 kWh'
    },
    serviceAreaSection: {
      title: 'Administratoren-Zugang und Servicebereich',
      manageAdminAccess: 'Administratoren-Zugang verwalten',
      addNewUser: '+ Neuen Benutzer hinzufügen',
      selectOneAdmin:
        'Bitte wählen Sie einen Administrator-Benutzer aus Ihrem Unternehmen, der alleiniger Ansprechpartner ist, falls Enphase Sie wegen des Vorgehens im Zusammenhang mit einem Lead kontaktieren möchte.',
      selectUser: 'Benutzer wählen',
      otherAdmin:
        '#Die anderen Administrator-Benutzer in der obigen Liste erhalten weiterhin Benachrichtigungen für alle neuen Leads und deren Aktualisierungen. Diese können ausgeschaltet werden, indem sie ihre Benachrichtigungs-Einstellungen entsprechend aktualisieren.',
      serviceArea: 'Servicebereich',
      addServiceAreas: 'Servicebereich hinzufügen'
    },
    addUserDialog: {
      yes: 'Ja'
    },
    acModule: {
      optIn: 'Anmeldung für die Installation von Enphase-AC-Modulen',
      description:
        'Der Hausbesitzer interessiert sich für ein Wechselstrom-Modul-basiertes System. Sie beschaffen und installieren die AC-Module. Enphase AC-Module kombinieren die neueste Mikro-Wechselrichter-Technologie von Enphase mit hocheffizienten PV-Modulen. Sie verbinden Ästhetik und Leistung in einem eleganten Produkt, das die Installationszeit verkürzt, weil Wechselrichter und Modul eine Einheit bilden. '
    },
    sampleQuotes: {
      title: 'Richtpreise für Leads',
      useSlider:
        'Benutzen Sie die Schieberegler unten, um zu sehen, wie Ihre Eingaben für die Preisspanne den Hausbesitzern als unverbindliche Preisspanne für verschiedene Systemgrößen ausgegeben werden',
      description:
        'Basierend auf Ihren Eingaben wird hier die Preisspanne angezeigt, die Hausbesitzer zu sehen bekommen. Sie können auch überprüfen, wie sich die Preisspanne je nach Systemgröße ändert.',
      solarOnly: 'PV-Installation',
      storageOnly: 'Speicher-Installation',
      solarStorage: 'PV- und Speicher-Installation',
      solarExpansion: 'PV-System-Erweiterung',
      turnkeyACM: 'Speicher-Installation + AC-Modul Upgrade',
      microUpgrade: 'Mikro-Wechselrichter-Aktualisierung',
      turnkeyIQSeries: 'Speicher-Installation + Mikro-Wechselrichter-Upgrade',
      installationACM: 'Speicher-Installation + AC-Modul Upgrade',
      installationIQSeries: 'Speicher-Installation + Mikro-Wechselrichter-Upgrade',
      installationSolar: 'PV-Installation',
      installationStorage: 'Speicher-Installation/-Erweiterung',
      turnkeyNew: 'Schlüsselfertiger Preis für Neukunden',
      turnKeyExisting: 'Schlüsselfertiger Preis für Bestandskunden',
      turnkeyNewUS: 'Komplettpreis für Hausbesitzer',
      installationUS: 'Nur Installationspreis für Hausbesitzer',
      installation: 'Angebote für Nur-Installation bei M-190-WR-Besitzern',
      turnkeyPrice: 'Schlüsselfertiger Preis',
      installation2: 'Nur-Installations-Preis für Empfehlungskunden',
      installation3: 'Nur-Installation-Preis für bestehende Hausbesitzer',
      microinverterFootnote:
        'Der Upgrade-Preis für Mikro-Wechselrichter kann hinzugefügt werden je nach alter des Sites',
      solar: 'PV',
      storage: 'Speicher'
    },
    operationMaintenance: {
      label: 'Anmeldung für O&M-Dienstleistungen',
      description:
        'Betriebs- und Wartungsdienste (O&M) beinhalten die Unterstützung und Wartung bestehender Enphase-Systeme und „Waisen-Systeme“ (Standorte mit einem inaktiven Installateur). Alle O&M-Leads enthalten vollständige Site-Details und Support-Verlauf. Für alle O&M-Leads gilt die Enphase-Standard-Produktgarantie. Eine vorherige Garantie auf Arbeitsleistungen gilt nicht für die „Waisen-Systeme“.'
    },
    leadProgram: {
      optIn: 'Opt-In für das Enphase-Leads-Programm',
      description:
        'Hausbesitzer wenden sich an Enphase, um Neuinstallationen, Upgrades und laufende Systemwartungen zu beauftragen. Als Enphase-Partner haben Sie jetzt die Möglichkeit, diese Hausbesitzer über das Enphase Leads-Programm zu bedienen, das Sie mit Solar-Interessenten zusammenbringt.',
      programHighlights: 'Highlights des Programms:',
      keyTerms1: 'Enphase stellt kostenlose qualifizierte Leads für ihr Serviceangebot zur Verfügung',
      keyTerms2: 'Kundenprofil und Projektdetails werden für jeden Lead vor dem ersten Kontakt bereitgestellt',
      keyTerms3: 'Enphase hilft bei Planung, Terminvereinbarung, Projekt-Updates  und technischem Support',
      keyTerms4:
        'Von den Installateuren wird erwartet, dass sie innerhalb von 2 Werktagen jeden Lead kontaktieren und ein Angebot schicken',
      keyTerms5: 'Im Rahmen des Programms dürfen nur Enphase-Produkte verwendet werden',
      leadProgramPreferences: 'Leads-Programm-Einstellungen ',
      someLeads:
        'Bei einigen Leads sind möglicherweise nur Installations-Services gefragt. Bitte geben Sie unten an, ob Sie solche Leads erhalten möchten.',
      tooltipTitle1:
        'Dienstleistungen, die Sie Hausbesitzern anbieten. Enphase wählt Hausbesitzer für Sie aus, basierend auf den von Ihnen gewählten Serviceangebot-Einstellungen.',
      turnKey: 'Schlüsselfertige Leistungen',

      tooltipTitle2: 'Sie bieten alle Geräte-, Planungss-, Genehmigungs- und Installationsdienste an',
      installationService: 'Nur-Installations-Dienste ',
      tooltipTitle3:
        'Hausbesitzer kauft die Enphase-Geräte im Enphase Store. Sie bieten die übrigen Geräte-, Planungss-, Genehmigungs- und Installationsdienste an.',
      solarNew: 'PV - Neuinstallationen',
      solarUpgrades: 'PV - Upgrades',
      storageNew: 'Speicher - Neuinstallationen'
    },
    textContent: {
      preference: {
        title: 'Leads-Programm-Einstellungen ',
        caption: 'Haftungsausschluss',
        description:
          'Enphase zeigt den Hausbesitzern die Preisspanne an, die sie für jede der Einstellungen unten vorgegeben habe. Dazu erfolgt ein Hinweis, dass diese Preisgestaltung ein Richtwert ist und den Arbeitsumfang nur für ein typisches System widerspiegelt. Die tatsächlichen Preise können sich je nach Standort, Dachtyp/-neigung, elektrischen Zusatzarbeiten usw. ändern.​',
        atleaseOne: 'Wählen Sie mindestens eine Dienstleistung aus'
      },
      programreview: {
        title: 'Programm-Übersicht',
        description:
          'Hausbesitzer wenden sich an Enphase, um Neuinstallationen, Upgrades und laufende Systemwartungen zu beauftragen. Als Enphase-Partner haben Sie jetzt die Möglichkeit, diese Hausbesitzer über das Enphase Leads-Programm zu bedienen, das Sie mit Solar-Interessenten zusammenbringt. Bitte überprüfen Sie die folgenden Eckpunkte und nehmen Sie Ihre Einstellungen für dieses Programm vor.'
      },
      keyProgramTerms: {
        title: 'Eckpunkte des Programms',
        enphaseProduct: 'Im Rahmen des Programms dürfen nur Enphase-Produkte verwendet werden',
        appointment: 'Enphase hilft bei der Planung von Terminen und bietet bei Bedarf weitere Unterstützung',
        contact: 'Von den Installateuren wird erwartet, dass sie jeden Lead innerhalb von 2 Werktagen kontaktieren',
        project: 'Kundenprofil und Projektdetails werden für jeden Lead vor dem ersten Kontakt bereitgestellt',
        verifiedAccount: 'Enphase stellt kostenlose qualifizierte Leads für ihr Serviceangebot zur Verfügung'
      },
      TurnKey: {
        title: 'Schlüsselfertige Leistungen',
        description: `Schlüsselfertige Dienstleistungen bedeutet, dass der Installateur das gesamte Material bereitstellt,  Genehmigungen einholt, das System plant, installiert und in Betrieb nimmt, wenn nötig. Der Installateur führt die Projekt- und Standortbewertung durch, bevor er ein detailliertes Angebot erstellt. Der angegebene Preis enthält die geschätzten Gesamtkosten für den Hausbesitzer für ein betriebsbereites System.`,
        solar: {
          // changed unit here
          indicativePricing: 'Unverbindliche Preisspanne pro Wp',
          quoteSizeIn: 'kW',
          main: 'Solar - Installation',
          sub: 'Die Installation eines neuen PV-Systems.',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Installateur',
              sub:
                'Gibt schlüsselfertige Preise an und beschafft alle erforderlichen Komponenten wie Module, Mikro-Wechselrichter (oder alternativ AC-Module), IQ Combiner-Box, Zubehör-Kit, Schutzschalter, Mobilfunk-Modem, Kabel und Gestell.'
            },
            assumptions: {
              main: 'Annahmen',
              sub:
                'Die Preisspanne gilt für einen typischen Standort und beinhaltet kein Upgrade des Hauptverteilers und kein spezielles Dach.'
            }
          }
        },
        storage: {
          indicativePricing: 'Unverbindliche Preisspanne pro kWh',
          indicativePricingStorageSlabs: 'Richtpreis pro kWh',
          main: 'Speicher-Installation',
          quoteSizeIn: 'kWh',
          sub: 'Die Installation eines neuen Speicher-Systems',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Installateur',
              sub:
                'Gibt schlüsselfertige Preise an und beschafft alle erforderlichen Komponenten wie Encharge Speicher, Enpower Schalter, Mobilfunk-Modem, Zubehör-Kit und Kabel'
            },
            assumptions: {
              main: 'Annahmen',
              sub: `Die unverbindliche Preisspanne beinhaltet kein Upgrade des Hauptverteilers.`
            }
          }
        },
        microinverter: {
          // changed unit here
          indicativePricing: 'Unverbindliche Preisspanne nur für Installation pro Wp',
          main: 'Mikro-Wechselrichter-Upgrade ',
          quoteSizeIn: 'kW',
          sub:
            'Mikro-Wechselrichter-Upgrade für ein PV-System der M-Serie (z. B. M-215, M-250) auf ein neues IQ-basiertes PV-System, das normalerweise mit einer "Speicher-Installation" einhergeht.',
          sub2:
            'Mikro-Wechselrichter-Upgrade für ein PV-System der M-Serie (z. B. M-215, M-250) auf ein neues IQ-basiertes PV-System',
          subUS:
            'Mikro-Wechselrichter-Upgrade für eine bestehende Solaranlage, um diese in eine neue IQ-basierte Solaranlage umzuwandeln.',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Installateur',
              sub: 'Bietet schlüsselfertige Preise und beschafft alle erforderlichen Materialien.'
            },
            assumptions: {
              main: 'Annahmen',
              sub: 'Die unverbindliche Preisspanne beinhaltet kein Upgrade des Hauptverteilers und der Module.'
            }
          }
        }
      },
      installationOnly: {
        title: 'Nur-Installations-Dienste (für spezielle Programme)',
        titleUS: 'Nur Dienstleistungen für die Installation',
        sub: '(z. B. Hausbesitzer mit M-190-basierten Solarmodulen, Enphase-Freunde und -Familienangehörige)',
        description:
          '„Nur-Installations-Dienste“ bedeutet, dass der Hausbesitzer die Enphase-Materialliste über den Enphase Store bezieht. Alle anderen Materialien und Dienstleistungen werden direkt vom Installateur bereitgestellt (Verkabelung, Gestell, Planung, Genehmigungen, Installation und Inbetriebnahme, wenn zutreffend).',
        solar: {
          quoteSizeIn: 'kW',
          // changed unit here
          indicativePricing: 'Unverbindliche Preisspanne nur für Installation pro Wp',
          main: 'Solar - Installation',
          sub:
            'Neuinstallation im Rahmen spezieller Programme oder vollständiges Upgrade eines M-190/M-210/M-175/D380-basierten PV-Systems',
          subUS: 'Die Installation eines neuen PV-Systems.',
          details: {
            homeOwner: {
              main: 'Hausbesitzer',
              sub:
                'Kauft das erforderliche Material im Enphase Store, z. B. AC-Module, IQ Combiner Box, Zubehör-Kit und Schutzschalter.'
            },
            installer: {
              main: 'Installateur',
              sub: 'Sorgt für Verkabelung, Gestell, Genehmigungen, Installation und Inbetriebnahme.'
            },
            assumptions: {
              main: 'Annahmen',
              sub: `Die  unverbindliche Preisspanne beinhaltet kein Upgrade des Hauptverteilers und kein spezielles Dach.`
            }
          }
        },
        storage: {
          quoteSizeIn: 'kWh',
          indicativePricing: 'Unverbindliche Preisspanne nur für Installation pro kWh',
          indicativePricingStorageSlabs: 'Richtpreis nur für die Installation pro kWh',
          main: 'Speicher-Installation',
          sub:
            'Speichererweiterung zu einem vorhandenen PV-System für spezielle Programme oder für ein M-190/M-210/M-175/D380-basiertes PV-System',
          subUS: 'Die Installation eines neuen Speicher-Systems',
          details: {
            homeOwner: {
              main: 'Hausbesitzer',
              sub:
                'Kauft das erforderliche Material im Enphase Store, z. B. Encharge Speicher, Enpower Schalter, Zubehör-Kit, Envoy Gateway und falls erforderlich IQ Combiner-Box, Mobilfunk-Modem und/oder Stromsensor (CT) '
            },
            installer: {
              main: 'Installateur',
              sub: 'Sorgt für Genehmigungen, die Installation und Inbetriebnahme.'
            },
            assumptions: {
              main: 'Annahmen',
              sub: `Die unverbindliche Preisspanne beinhaltet kein Upgrade des Hauptverteilers.`
            }
          }
        },
        microinverter: {
          quoteSizeIn: 'kW',
          // changed unit here
          indicativePricing: 'Unverbindliche Preisspanne nur für Installation pro Wp',
          main: 'Mikro-Wechselrichter - Upgrade',
          sub: `Mikro-Wechselrichter-Upgrade für ein M-190/M-210/ M-175/D380-basiertes PV-System auf ein neues IQ-basiertes PV-System, das normalerweise mit einer "Speicher-Installation" einhergeht.`,
          sub2:
            'Mikro-Wechselrichter-Upgrade für ein M-190/M-210/ M-175/D380-basiertes PV-System auf ein neues IQ-basiertes PV-System',
          subUS:
            'Mikro-Wechselrichter-Upgrade für eine bestehende Solaranlage, um diese in eine neue IQ-basierte Solaranlage umzuwandeln.',
          details: {
            homeOwner: {
              main: 'Hausbesitzer',
              sub:
                'Kauft das erforderliche Material im Enphase Store, z. B. Mikro-Wechselrichter, IQ Combiner Box, Zubehör-Kit und Schutzschalter.'
            },
            installer: {
              main: 'Installateur',
              sub:
                'Sorgt für Genehmigungen, den Austausch, die Wiederinbetriebnahme und das Recycling alter Mikro-Wechselrichter.​'
            },
            assumptions: {
              main: 'Annahmen',
              sub: `Die unverbindliche Preisspanne beinhaltet kein Upgrade des Hauptverteilers und der Gestelle.`
            }
          }
        }
      },
      omServices: {
        title: 'Enphase O&M Dienstleistungen',
        om: {
          main: 'Anmeldung für Enphase O&M Dienstleistungen',
          pre: '– inkl. "Waisen-Systeme"',
          sub: `Betriebs- und Wartungsdienste (O&M) beinhalten die Unterstützung und Wartung bestehender Enphase-Systeme und „Waisen-Systeme“ (Standorte mit einem inaktiven Installateur). Alle O&M-Leads enthalten vollständige Site-Details und Support-Verlauf. Für alle O&M-Leads gilt die Enphase-Standard-Produktgarantie. Eine vorherige Garantie auf Arbeitsleistungen gilt nicht für die „Waisen-Systeme“.`
        }
      },
      otherServices: {
        title: 'Andere Einstellungen',
        buy: 'Wir sind bereit, Produkte zu kaufen von',
        acModule: {
          main: 'Wir sind bereit, Enphase Energized Wechselstrom-Module zu installieren',
          sub1: `Enphase Energized AC-Module`,
          sub2: `kombinieren die neueste Mikro-Wechselrichter-Technologie von Enphase mit hocheffizienten PV-Modulen. Sie verbinden Ästhetik und Leistung in einem eleganten Produkt, das die Installationszeit verkürzt, weil Wechselrichter und Modul eine Einheit bilden. Wenn Sie diese Option auswählen, werden Sie von Enphase an die Hausbesitzer vermittelt, die interessiert sind, AC-Module zu installieren.`
        },
        enstore: {
          main: 'Enphase Store',
          sub1: `Enphase Store `,
          sub2: `ist ein One-Stop-Shop für Solar- und Speicherprodukte mit garantierter Lieferung. Im Store gilt keine Mindestbestellmenge und er bietet Versand mit Echtzeit-Verfolgung und Online-Tracking.​`,
          subIndia: `is a one-stop-shop for Solar products with guaranteed delivery. Store requires no minimum order quantity and provides real time delivery and online tracking.​`
        },
        distributor: {
          main: 'Enphase-Großhändler ',
          sub1: `Enphase-Großhändler `,
          sub2: ` liefern alle Enphase-Produkte und anderes benötigtes Zubehör für Ihre Solar- und Speicherlösung​`,
          subIndia: ` supply all Enphase products and other required accessories for your Solar solution​`
        },
        permitAssistance: {
          main: 'Wir sind an einem Genehmigungsbeschaffungsdienst von Enphase interessiert',
          sub: `Enphase unterstützt Sie mit PV- und Speichergenehmigungs-Paketen für Ihre Projekte, die Sie den örtlichen Behörden zur Genehmigung vorlegen können.`
        },
        financeProvider: {
          main: 'Wir bieten Finanzierungsmöglichkeiten für Hausbesitzer',
          no: 'Nein',
          yes: 'Ja',
          financeProvider: 'Finanzdienstleister',
          others: 'Andere Versorger',
          addMultiple: 'Bis zu 3 (durch Komma getrennt)',
          requiredSelection: 'Notwendige Auswahl',
          atLeastOneError: `Ungültige Finanzdienstleister (bei Auswahl von "Andere Anbieter" mindestens einen Anbieternamen eingeben)`
        }
      },
      serviceArea: {
        name: 'Service-Bereiche hinzufügen',
        sub: 'Kein Bereich hinzugefügt',
        description: `Bitte fügen Sie Ihr Serviceangebot hinzu. Dies ist erforderlich, damit Enphase Sie mit potenziellen Leads von Hausbesitzern abgleichen kann.`
      },
      qualifyLeads: {
        mainSection: 'Möchten Sie, dass Enphase Berater die Leads in einem Telefongespräch qualifizieren, bevor diese an Sie weitergereicht werden?',
        moreInfo: 'Bitte teilen Sie uns mit, falls wir bestimmte Informationen Ihrer Leads sammeln sollen.',
        infoWeCollect: 'Sie möchten wissen, welche Informationen wir im Rahmen unseres Qualifikationsprozesses sammeln',
        subSection: 'Möchten Sie, dass ein Lead nach der Qualifikation an einen Ihrer Berater weitergeleitet wird, während der Hauseigentümer im Gespräch mit uns ist?',
        details: 'Bitte wählen Sie einen Admin-Benutzer Ihres Unternehmens aus, an den solche Leads weitergeleitet werden sollen',
        icCheckList: 'Qualification Checklist',
        selectOption: 'Please select an option',
        selectUser: 'Please select a user',
      }
    },
    textContentAu: {
      preference: {
        title: 'Leads-Programm-Einstellungen',
        caption: 'Haftungsausschluss',
        description: `Enphase zeigt den Hausbesitzern die Preisspanne an, die sie für jede der Einstellungen unten vorgegeben habe. Dazu erfolgt ein Hinweis, dass diese Preisgestaltung ein Richtwert ist und den Arbeitsumfang nur für ein typisches System widerspiegelt. Die tatsächlichen Preise können sich je nach Standort, Dachtyp/-neigung, elektrischen Zusatzarbeiten usw. ändern.​`,
        atleaseOne: `* Wählen Sie mindestens einen Service aus`
      },
      programreview: {
        title: 'Programm-Übersicht',
        description: `Hausbesitzer wenden sich an Enphase, um Neuinstallationen, Upgrades und laufende Systemwartungen zu beauftragen. Als Enphase-Partner haben Sie jetzt die Möglichkeit, diese Hausbesitzer über das Enphase Leads-Programm zu bedienen, das Sie mit Solar-Interessenten zusammenbringt. Bitte überprüfen Sie die folgenden Eckpunkte und nehmen Sie Ihre Einstellungen für dieses Programm vor.`
      },
      keyProgramTerms: {
        title: 'Wichtige Bedingungen für das Programm',
        enphaseProduct: 'Im Rahmen des Programms dürfen nur Enphase-Produkte verwendet werden',
        appointment: 'Enphase hilft bei der Terminplanung und bietet bei Bedarf weitere Unterstützung',
        contact: 'Von den Installateuren wird erwartet, dass sie  jeden Lead innerhalb von 2 Werktagen kontaktieren',
        project: 'Kundenprofil und Projektdetails werden für jeden Lead vor dem ersten Kontakt bereitgestellt',
        verifiedAccount: 'Enphase stellt kostenlose qualifizierte Leads für ihr Serviceangebot zur Verfügung'
      },
      TurnKey: {
        title: 'Schlüsselfertige Leistungen',
        description: `Schlüsselfertige Leistungen bedeutet, dass der Installateur das gesamte Material bereitstellt,  Genehmigungen einholt, das System plant, installiert und in Betrieb nimmt, wenn nötig. Der Installateur führt die Projekt- und Standortbewertung durch, bevor er ein detailliertes Angebot erstellt. Der angegebene Preis enthält die geschätzten Gesamtkosten für den Hausbesitzer für ein betriebsbereites System.`,
        solar: {
          indicativePricing: 'Unverbindliche Preisspanne pro Watt',
          quoteSizeIn: 'kW',
          main: 'Solar - Installation',
          sub: 'Die Installation eines neuen PV-Systems',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Installateur',
              sub:
                'Gibt schlüsselfertige Preise an und beschafft alle erforderlichen Komponenten wie Module, Mikro-Wechselrichter, Zubehör, Schutzschalter, Mobilfunk-Modem, Kabel und Gestell.'
            },
            assumptions: {
              main: 'Annahmen',
              sub: `Die Preisspanne gilt für einen typischen Standort und beinhaltet kein Upgrade des Hauptverteilers und kein spezielles Dach.`
            }
          }
        },
        storage: {
          indicativePricing: 'Unverbindliche Preisspanne pro kWh',
          main: 'Speicher-Installation',
          quoteSizeIn: 'kWh',
          sub: 'Die Installation eines neuen Speicher-Systems',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Installateur',
              sub:
                'Gibt schlüsselfertige Preise an und beschafft alle erforderlichen Komponenten wie ACB Speicher, Befestigung, Kabel und Schutzschalter'
            },
            assumptions: {
              main: 'Annahmen',
              sub: `Die unverbindliche Preisspanne beinhaltet kein Upgrade des Hauptverteilers.`
            }
          }
        },
        microinverter: {
          indicativePricing: 'Unverbindliche Preisspanne pro Watt',
          main: 'Mikro-Wechselrichter - Upgrade',
          quoteSizeIn: 'kW',
          sub:
            'Mikro-Wechselrichter-Upgrade für ein PV-System der M-Serie (z. B. M-215, M-250) auf ein neues IQ-basiertes PV-System, das normalerweise mit einer "Speicher-Installation" einhergeht.',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Installateur',
              sub: 'Gibt schlüsselfertige Preise an und beschafft alle erforderlichen Komponenten.'
            },
            assumptions: {
              main: 'Annahmen',
              sub: 'Die unverbindliche Preisspanne beinhaltet kein Upgrade des Hauptverteilers und der Module'
            }
          }
        },
        solarExpansion: {
          indicativePricing: 'Unverbindliche Preisspanne pro Watt',
          quoteSizeIn: 'kW',
          main: 'PV-System-Erweiterung',
          sub: 'Erweiterung bestehender PV-Systeme von Enphase und anderen Herstellern',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Installateur',
              sub: 'Gibt schlüsselfertige Preise an und beschafft alle erforderlichen Komponenten.'
            },
            assumptions: {
              main: 'Annahmen',
              sub: `Die Preisspanne gilt für einen typischen Standort und beinhaltet kein Upgrade des Hauptverteilers und kein spezielles Dach.`
            }
          }
        }
      },
      installationOnly: {
        title: 'Nur-Installations-Dienste (für spezielle Programme)',
        sub: '(z. B. unbetreute Systeme, die Austausch/Reparatur benötigen, Speicher-Upgrade, Envoy-Upgrade)',
        description:
          'Nur-Installations-Dienste“ bedeutet, dass der Hausbesitzer die Enphase-Materialliste über den Enphase Store bezieht. Alle anderen Materialien und Dienstleistungen werden direkt vom Installateur bereitgestellt (Verkabelung, Gestell, Planung, Genehmigungen, Installation und Inbetriebnahme, wenn zutreffend).',
        solar: {
          quoteSizeIn: 'kW',
          // changed unit here
          indicativePricing: 'Unverbindliche Preisspanne nur für Installation pro Wp',
          main: 'Solar - Installation',
          sub: `Neuinstallation im Rahmen spezieller Programme wie Empfehlungen durch Enphase-Kunden, Installateure und Mitarbeiter`,
          details: {
            homeOwner: {
              main: 'Hausbesitzer',
              sub: `Kauft das erforderliche Material im Enphase Store, z. B. Mikro-Wechselrichter, Zubehör-Kit, Envoy und Schutzschalter.`
            },
            installer: {
              main: 'Installateur',
              sub: 'Sorgt für Module, Verkabelung, Gestell, Genehmigungen, Installation und Inbetriebnahme.'
            },
            assumptions: {
              main: 'Annahmen',
              sub: `Die Preisspanne gilt für einen typischen Standort und beinhaltet kein Upgrade des Hauptverteilers und kein spezielles Dach.`
            }
          }
        },
        storage: {
          quoteSizeIn: 'kWh',
          indicativePricing: 'Unverbindliche Preisspanne nur für Installation pro kWh',
          main: 'Speicher – Erweiterung oder Installation',
          sub:
            'Erweiterung oder Installation eines ACB Speichers in ein vorhandenes PV-System im Rahmen spezieller Programme',
          details: {
            homeOwner: {
              main: 'Hausbesitzer',
              sub: 'Kauft das erforderliche Material im Enphase Store, z. B. ACB Speicher, Befestigung'
            },
            installer: {
              main: 'Installateur',
              sub: 'Sorgt für die Installation und Inbetriebnahme.'
            },
            assumptions: {
              main: 'Annahmen',
              sub: `Die unverbindliche Preisspanne beinhaltet kein Upgrade des Hauptverteilers.`
            }
          }
        },
        microinverter: {
          quoteSizeIn: 'kW',
          // changed unit here
          indicativePricing: 'Unverbindliche Preisspanne nur für Installation pro Wp',
          main: 'Mikro-Wechselrichter - Upgrade',
          sub: `Mikro-Wechselrichter-Upgrade für ein M-190/M-210/ M-175/D380-basiertes PV-System auf ein neues IQ-basiertes PV-System, das normalerweise mit einer "Speicher-Installation" einhergeht."`,
          details: {
            homeOwner: {
              main: 'Hausbesitzer',
              sub:
                'Kauft das erforderliche Material im Enphase Store, z. B. Mikro-Wechselrichter, IQ Combiner Box, Zubehör-Kit und Schutzschalter.​'
            },
            installer: {
              main: 'Installateur',
              sub:
                'Sorgt für Genehmigungen, den Austausch, die Wiederinbetriebnahme und das Recycling alter Mikro-Wechselrichter.'
            },
            assumptions: {
              main: 'Annahmen',
              sub: `Die unverbindliche Preisspanne beinhaltet kein Upgrade des Hauptverteilers und der Gestelle`
            }
          }
        }
      },
      omServices: {
        title: 'Enphase O&M Services',
        om: {
          main: 'Anmeldung für Enphase O&M Dienstleistungen',
          pre: '– inkl. "Waisen-Systeme"',
          sub: `Betriebs- und Wartungsdienste (O&M) beinhalten die Unterstützung und Wartung bestehender Enphase-Systeme und „Waisen-Systeme“ (Standorte mit einem inaktiven Installateur). Alle O&M-Leads enthalten vollständige Site-Details und Support-Verlauf. Für alle O&M-Leads gilt die Enphase-Standard-Produktgarantie. `
        }
      },
      otherServices: {
        title: 'Andere Einstellungen',
        buy: 'Ich bin bereit, Produkte zu kaufen von',
        acModule: {
          main: 'Ich bin bereit, Enphase Energized AC-Module zu installieren',
          sub1: `Enphase Energized AC Modules `,
          sub2: `kombinieren die neueste Mikro-Wechselrichter-Technologie von Enphase mit hocheffizienten PV-Modulen. Sie verbinden Ästhetik und Leistung in einem eleganten Produkt, das die Installationszeit verkürzt, weil Wechselrichter und Modul eine Einheit bilden. Wenn Sie diese Option auswählen, werden Sie von Enphase an die Hausbesitzer vermittelt, die interessiert sind, AC-Module zu installieren.`
        },
        enstore: {
          main: 'Enphase Store',
          sub1: `Enphase Store `,
          sub2: `ist ein One-Stop-Shop für Solar- und Speicherprodukte mit garantierter Lieferung. Im Store gilt keine Mindestbestellmenge und er bietet Versand mit Echtzeit-Verfolgung und Online-Tracking.​`
        },
        distributor: {
          main: 'Enphase-Großhändler ',
          sub1: `Enphase-Großhändler `,
          sub2: `liefern alle Enphase-Produkte und anderes benötigtes Zubehör für Ihre Solar- und Speicherlösung​`
        }
      },
      serviceArea: {
        name: 'Service-Bereiche hinzufügen',
        sub: 'Kein Bereich hinzugefügt',
        description: `Bitte fügen Sie Ihr Serviceangebot hinzu. Dies ist erforderlich, damit Enphase Sie mit potenziellen Leads von Hausbesitzern abgleichen kann.`
      }
    },
    getLink: `Link abrufen`,
    linkSENewLeads: `Estimator Link des Systems für neue Informationen`,
    shareSELink: `Teilen Sie diesen Link Ihren Kunden mit, damit diese ihre Enphase-Systemgröße schätzen und ihre Details übermitteln können, um Informationen in Ihrem Enlighten Manager zu erhalten`
  }
};

export default leadPreferences;
